"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var Main_1 = __importDefault(require("components/Layout/Main"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var analytics_1 = require("utils/analytics");
var backend_1 = require("utils/backend");
var chargebee_1 = require("utils/chargebee");
var dateTime_1 = require("utils/dateTime");
var HoCs_1 = require("utils/HoCs");
var single_1 = require("utils/selectors/single");
var CardLayout_1 = __importDefault(require("../styles/CardLayout"));
var ColumnLayout_1 = __importDefault(require("../styles/ColumnLayout"));
var BillingSettings = function () {
    var _a;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var _b = __read((0, react_1.useState)(null), 2), subscrData = _b[0], setSubscrData = _b[1];
    var _c = __read((0, chargebee_1.useFetchSubscriptionForCompany)(), 1), fetchSubscription = _c[0];
    var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchSubscription()()];
                case 1:
                    result = _a.sent();
                    setSubscrData(result === null || result === void 0 ? void 0 : result.data);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        fetchData();
    }, []);
    var trackButtonClicked = (0, analytics_1.usePreparedTracker)('Button Clicked');
    var handleChangePaymentClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var cbInstance;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trackButtonClicked({ action: 'Change Payment Method' });
                    return [4 /*yield*/, (0, chargebee_1.getCbInstanceAsync)()];
                case 1:
                    cbInstance = _a.sent();
                    cbInstance.openCheckout({
                        hostedPage: function () {
                            return __awaiter(this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, (0, backend_1.callBackendFn)('payments-generateUpdatePaymentMethodUrl', { userId: profile === null || profile === void 0 ? void 0 : profile.id })];
                                        case 1:
                                            result = _a.sent();
                                            return [2 /*return*/, result.data];
                                    }
                                });
                            });
                        },
                        close: function () {
                            fetchData();
                        },
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var history = (0, react_router_dom_1.useHistory)();
    var handleChangePlan = function () {
        trackButtonClicked({ action: 'View Billing Plan' });
        history.push('/settings/billing/plan');
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Billing Settings", description: "Billing Settings" }), (0, jsx_runtime_1.jsx)(Main_1.default, __assign({ hasSidebar: true }, { children: (0, jsx_runtime_1.jsxs)(ColumnLayout_1.default, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "Plans and pricing" })), (0, jsx_runtime_1.jsxs)(CardLayout_1.default, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: (company === null || company === void 0 ? void 0 : company.plan) && "".concat(company.plan, " Plan") })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: (subscrData === null || subscrData === void 0 ? void 0 : subscrData.subscription)
                                        && "".concat(subscrData.subscription.subscription_items[0].amount / 100, " ").concat(subscrData === null || subscrData === void 0 ? void 0 : subscrData.subscription.base_currency_code) })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: (company === null || company === void 0 ? void 0 : company.planStatus) === 'active' && company.planFrequency && "Billed ".concat(company.planFrequency) })), !(company === null || company === void 0 ? void 0 : company.hasChargebee) && (company === null || company === void 0 ? void 0 : company.plan) === 'Growth' && company.planStatus === 'in_trial' && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Free Trial" })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: [((company === null || company === void 0 ? void 0 : company.freeTrialFinishDate) && (0, dateTime_1.daysUntil)(company.freeTrialFinishDate.toDate())) || 0, " days left on free trial"] }))] })), !(company === null || company === void 0 ? void 0 : company.hasChargebee) && (company === null || company === void 0 ? void 0 : company.plan) === 'Start-Up' && (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Free forever" })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: handleChangePlan, sx: { mt: 1, width: '50%' } }, { children: "Change plan" }))] }), (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "Payment method" })), (0, jsx_runtime_1.jsxs)(CardLayout_1.default, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: ((_a = subscrData === null || subscrData === void 0 ? void 0 : subscrData.card) === null || _a === void 0 ? void 0 : _a.first_name) && "".concat(subscrData === null || subscrData === void 0 ? void 0 : subscrData.card.first_name, " ").concat(subscrData === null || subscrData === void 0 ? void 0 : subscrData.card.last_name) })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: (subscrData === null || subscrData === void 0 ? void 0 : subscrData.card) && (subscrData === null || subscrData === void 0 ? void 0 : subscrData.card.masked_number) })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: (subscrData === null || subscrData === void 0 ? void 0 : subscrData.card) && (subscrData === null || subscrData === void 0 ? void 0 : subscrData.card.expiry_month) && "".concat(subscrData === null || subscrData === void 0 ? void 0 : subscrData.card.expiry_month, "/").concat(subscrData === null || subscrData === void 0 ? void 0 : subscrData.card.expiry_year) })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ sx: { mt: 1, width: '75%' }, onClick: handleChangePaymentClick, disabled: !subscrData }, { children: "Change payment method" }))] })] }) }))] }));
};
exports.default = (0, HoCs_1.HasCompanyHoC)(BillingSettings);
